import { adaptParkingProductToItem } from './adaptParkingProductToItem';
import { adaptAncillaryToItems } from './adaptAncillaryToItems';
import { flatten } from '../../../../../../../shared/utils/flatten';
import { INewBooking } from '../../../../../../domain/booking/models/INewBooking';

export function adaptNewBookingToItems(booking: INewBooking) {
	if (!booking.parkingProduct) {
		return undefined;
	}

	const parkingProductItem = adaptParkingProductToItem(
		booking.parkingProduct,
		booking.promoCode,
	);

	const nestedAncillaryItems = booking.ancillaries.map(adaptAncillaryToItems);
	const ancillaryItems = flatten(nestedAncillaryItems);

	return [parkingProductItem, ...ancillaryItems];
}
